interface GRecaptchaWindow extends Window {
    recaptchaInitCallback: () => void;
    grecaptcha: any;
}

require('./recaptcha.component.scss');

export class RecaptchaComponent {
    public component: JQuery;
    public componentName = `recaptcha-component`;
    private static index = 0;
    private _gWindow = window as unknown as GRecaptchaWindow;

    constructor(
        private _disableRecaptcha: boolean,
        private _onsuccessCallback: () => void,
        private _disabledClasses = ``,
    ) {
        this.component = $(`[data-component='${this.componentName}']`);
        if (this.component.length) {
            this._onInit();
        }
    }

    private _onInit() {
        if (!this._disableRecaptcha) {
            // Verify window is defined
            if (typeof window === `undefined`) {
                return;
            }

            const key = `recaptchaInitCallback_${RecaptchaComponent.index++}`;

            // Setup recaptchaInitCallback
            this._gWindow[key] = () => {
                this._render();
            };

            // Setup recaptchaScript on page
            const recaptchaScript = document.createElement(`script`);
            recaptchaScript.setAttribute(`src`, `https://www.google.com/recaptcha/api.js?onload=${key}&render=explicit`);
            recaptchaScript.setAttribute(`async`, ``);
            recaptchaScript.setAttribute(`defer`, ``);
            (document.body || document.head).appendChild(recaptchaScript);

            // Else render disabled recaptcha
        } else {
            this.component.html(`<div class="disabled-recaptcha ${this._disabledClasses}"></div>`);
        }
    }

    /**
     * Invokes grecaptcha check
     */
    public execute() {
        if (!this._disableRecaptcha && this._grecaptchaDefined()) {
            this._gWindow.grecaptcha.execute();
        } else {
            this._onsuccessCallback();
        }
    }

    /**
     * Resets grecaptcha to default state
     */
    public reset() {
        if (!this._disableRecaptcha && this._grecaptchaDefined()) {
            this._gWindow.grecaptcha.reset();
        }
    }

    /**
     * Verifies window.grecaptcha is available
     * @private
     */
    private _grecaptchaDefined() {
        // Verify window is defined
        if (typeof window === `undefined`) {
            return false;
        }

        // Verify grecaptcha is defined
        if (!this._gWindow.grecaptcha) {
            return false;
        }

        // Else assume defined
        return true;
    }

    /**
     * Renders grecaptcha
     * @private
     */
    private _render() {
        if (this._grecaptchaDefined()) {
            this._gWindow.grecaptcha.render(this.component.get(0), {
                badge: `inline`,
                callback: this._onsuccessCallback,
                sitekey: `6Lep2aoUAAAAANQkUEv5nX1MO9WBOpW4LE7Ck62C`,
                size: `invisible`,
            });
        }
    }
}
